export default __webpack_public_path__ + "static/media/bg4_m.fc1360dc.png";